import { inject, Injectable } from '@angular/core';
import { BaseSearchService, SearchFieldResult } from '@myarvato/components/search-widget';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MyArvatoEnvironment } from '@myarvato/shared/models';
import { TransportSearchIndexDto } from '@myarvato/modules/transport/models';

@Injectable()
export class TransportSearchService extends BaseSearchService<TransportSearchIndexDto> {
  private readonly environment = inject(MyArvatoEnvironment);
  private readonly httpClient = inject(HttpClient);

  private requestOptions = {
    headers: new HttpHeaders({
      'x-skip-all-interceptor-handling': 'true',
      'x-skip-loading-interceptor-handling': 'true',
      'x-error-message-target-key': 'none',
    }),
  };

  /**
   * Retrieves an order by search string.
   * @param searchTerm The search term to filter orders.
   * @returns An observable that emits the order details.
   */
  public override getSearchIndex(searchTerm: string): Observable<TransportSearchIndexDto[]> {
    return this.httpClient.post<TransportSearchIndexDto[]>(
      `${this.environment.url.api}Transport/Search`,
      {
        searchTerm: searchTerm.trim(),
      },
      this.requestOptions,
    );
  }

  public override findSearchField(item: TransportSearchIndexDto): SearchFieldResult | null {
    const matchingFieldValue = item.searchStringResult;
    const match = item.searchString;

    const highlightedValue = matchingFieldValue.replace(match, `<mark>${match}</mark>`);
    return { propertyName: item.fieldName, highlightedValue: highlightedValue };
  }
}
